import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_sentryserver_2936ffe2 from 'nuxt_plugin_sentryserver_2936ffe2' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7904e34c from 'nuxt_plugin_sentryclient_7904e34c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_5434d9f0 from 'nuxt_plugin_plugin_5434d9f0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtplugin1e61bf69_77140798 from 'nuxt_plugin_nuxtplugin1e61bf69_77140798' // Source: ./nuxt.plugin.1e61bf69.js (mode: 'server')
import nuxt_plugin_gtm_4df3f474 from 'nuxt_plugin_gtm_4df3f474' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuescrollto_27064a2b from 'nuxt_plugin_vuescrollto_27064a2b' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_daf83c74 from 'nuxt_plugin_cookieuniversalnuxt_daf83c74' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_70f72046 from 'nuxt_plugin_pluginutils_70f72046' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_a3af0c30 from 'nuxt_plugin_pluginrouting_a3af0c30' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_27860af2 from 'nuxt_plugin_pluginmain_27860af2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_coreplugin05f8043b_261252c4 from 'nuxt_plugin_coreplugin05f8043b_261252c4' // Source: ./core.plugin.05f8043b.js (mode: 'all')
import nuxt_plugin_pluginse2etesting4157b7de_e0a4b778 from 'nuxt_plugin_pluginse2etesting4157b7de_e0a4b778' // Source: ./plugins.e2e-testing.4157b7de.js (mode: 'all')
import nuxt_plugin_pluginslogger3db8ce72_21ed76a0 from 'nuxt_plugin_pluginslogger3db8ce72_21ed76a0' // Source: ./plugins.logger.3db8ce72.js (mode: 'all')
import nuxt_plugin_pluginscontext6a18bf3d_61f33ce6 from 'nuxt_plugin_pluginscontext6a18bf3d_61f33ce6' // Source: ./plugins.context.6a18bf3d.js (mode: 'all')
import nuxt_plugin_image_263589ce from 'nuxt_plugin_image_263589ce' // Source: ./image.js (mode: 'all')
import nuxt_plugin_deviceplugin_4b5cd7a9 from 'nuxt_plugin_deviceplugin_4b5cd7a9' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_f5d0b88c from 'nuxt_plugin_workbox_f5d0b88c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_e852de66 from 'nuxt_plugin_metaplugin_e852de66' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_df03937e from 'nuxt_plugin_iconplugin_df03937e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_cookieStore_59bf1ba7 from 'nuxt_plugin_cookieStore_59bf1ba7' // Source: ../plugins/cookieStore (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_vimeoplayer_c28cd600 from 'nuxt_plugin_vimeoplayer_c28cd600' // Source: ../plugins/vimeo-player (mode: 'all')
import nuxt_plugin_vueplaceholders_1b021dbd from 'nuxt_plugin_vueplaceholders_1b021dbd' // Source: ../plugins/vue-placeholders (mode: 'all')
import nuxt_plugin_I18nIsoCountries_2f77a6fa from 'nuxt_plugin_I18nIsoCountries_2f77a6fa' // Source: ../plugins/I18nIsoCountries (mode: 'all')
import nuxt_plugin_observeVisibility_34addc98 from 'nuxt_plugin_observeVisibility_34addc98' // Source: ../plugins/observeVisibility (mode: 'all')
import nuxt_plugin_tooltip_ba49f866 from 'nuxt_plugin_tooltip_ba49f866' // Source: ../plugins/tooltip (mode: 'all')
import nuxt_plugin_vueSocials_65f27b94 from 'nuxt_plugin_vueSocials_65f27b94' // Source: ../plugins/vueSocials (mode: 'all')
import nuxt_plugin_meta_5f2b1dfc from 'nuxt_plugin_meta_5f2b1dfc' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Sogni di cristallo","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Sogni di cristallo"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.sognidicristallo.com\u002Fandroid-chrome-512x512.png"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?v=2"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png?v=2"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg?v=2","color":"#000000"}],"script":[{"hid":"ekomi","id":"ekomi","src":"\u002FexternalScript\u002FekomiWidget.js","type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fapplepay.cdn-apple.com\u002Fjsapi\u002Fv1\u002Fapple-pay-sdk.js"},{"hid":"hubspot","type":"text\u002Fjavascript","id":"hs-script-loader","async":true,"defer":true,"src":"\u002F\u002Fjs.hs-scripts.com\u002F8724965.js"},{"charset":"utf-8","type":"text\u002Fjavascript","src":"\u002F\u002Fjs.hsforms.net\u002Fforms\u002Fembed\u002Fv2.js"},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fswiper@9\u002Fswiper-element-bundle.min.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TL8XGCL')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TL8XGCL&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_2936ffe2 === 'function') {
    await nuxt_plugin_sentryserver_2936ffe2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7904e34c === 'function') {
    await nuxt_plugin_sentryclient_7904e34c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_5434d9f0 === 'function') {
    await nuxt_plugin_plugin_5434d9f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin1e61bf69_77140798 === 'function') {
    await nuxt_plugin_nuxtplugin1e61bf69_77140798(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4df3f474 === 'function') {
    await nuxt_plugin_gtm_4df3f474(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_27064a2b === 'function') {
    await nuxt_plugin_vuescrollto_27064a2b(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_daf83c74 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_daf83c74(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_70f72046 === 'function') {
    await nuxt_plugin_pluginutils_70f72046(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_a3af0c30 === 'function') {
    await nuxt_plugin_pluginrouting_a3af0c30(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_27860af2 === 'function') {
    await nuxt_plugin_pluginmain_27860af2(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin05f8043b_261252c4 === 'function') {
    await nuxt_plugin_coreplugin05f8043b_261252c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting4157b7de_e0a4b778 === 'function') {
    await nuxt_plugin_pluginse2etesting4157b7de_e0a4b778(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslogger3db8ce72_21ed76a0 === 'function') {
    await nuxt_plugin_pluginslogger3db8ce72_21ed76a0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext6a18bf3d_61f33ce6 === 'function') {
    await nuxt_plugin_pluginscontext6a18bf3d_61f33ce6(app.context, inject)
  }

  if (typeof nuxt_plugin_image_263589ce === 'function') {
    await nuxt_plugin_image_263589ce(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_4b5cd7a9 === 'function') {
    await nuxt_plugin_deviceplugin_4b5cd7a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_f5d0b88c === 'function') {
    await nuxt_plugin_workbox_f5d0b88c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_e852de66 === 'function') {
    await nuxt_plugin_metaplugin_e852de66(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_df03937e === 'function') {
    await nuxt_plugin_iconplugin_df03937e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieStore_59bf1ba7 === 'function') {
    await nuxt_plugin_cookieStore_59bf1ba7(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_vimeoplayer_c28cd600 === 'function') {
    await nuxt_plugin_vimeoplayer_c28cd600(app.context, inject)
  }

  if (typeof nuxt_plugin_vueplaceholders_1b021dbd === 'function') {
    await nuxt_plugin_vueplaceholders_1b021dbd(app.context, inject)
  }

  if (typeof nuxt_plugin_I18nIsoCountries_2f77a6fa === 'function') {
    await nuxt_plugin_I18nIsoCountries_2f77a6fa(app.context, inject)
  }

  if (typeof nuxt_plugin_observeVisibility_34addc98 === 'function') {
    await nuxt_plugin_observeVisibility_34addc98(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_ba49f866 === 'function') {
    await nuxt_plugin_tooltip_ba49f866(app.context, inject)
  }

  if (typeof nuxt_plugin_vueSocials_65f27b94 === 'function') {
    await nuxt_plugin_vueSocials_65f27b94(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_5f2b1dfc === 'function') {
    await nuxt_plugin_meta_5f2b1dfc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
